export type IconProps = {
  className?: string;
};

export default function ArrowDown({ className }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M17 6L10 13L3 6" strokeWidth="1.5" />
    </svg>
  );
}
